<template>
  <Modal
    :title="'Create RSS Widget'"
    :okButtonLabel="'Create'"
    :modalStyles="{ width: '500px' }"
    :okFunction="createRssWidget"
    :disabled="disableOkButton"
    @close="$emit('closeModal')"
    @closeModal="closeModal"
  >
    <template #body>
      <div class="group-body">
        <div class="rss-preview">
          <RssViewer :setting="rssSetting" isPreview @handleRssLink="handleRssLink" />
        </div>

        <div class="form-group">
          <label class="label" for="widgetName">
            <div>Widget Name</div>
            <input
              type="text"
              name="widgetName"
              id="widgetName"
              required
              v-model="name"
              placeholder="Set widget's name"
              maxlength="40"
            />
          </label>
        </div>

        <div class="form-group">
          <label class="label" for="rssLink">
            <div>RSS Feed URL</div>
            <input
              type="text"
              name="rssLink"
              id="rssLink"
              required
              v-model="rssLink"
              placeholder="https://example.com/feed.xml"
            />
          </label>
        </div>

        <div class="form-group">
          <div>Theme</div>
          <div class="theme-options">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                id="themeColorWhite"
                name="theme"
                value="white"
                v-model="theme"
              />
              <label class="custom-control-label" for="themeColorWhite">White</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                type="radio"
                class="custom-control-input"
                id="themeColorBlack"
                name="theme"
                value="black"
                v-model="theme"
              />
              <label class="custom-control-label" for="themeColorBlack">Black</label>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@/components/common/Modal.vue';
  import RssViewer from '@/components/rssViewer/RssViewer.vue';
  import { getRSSAppSettings } from '@/helpers/utils';

  export default {
    name: 'CreateRssWidgetModal',

    components: {
      Modal,
      RssViewer,
    },

    data() {
      return {
        name: 'RSS Widget',
        duration: 15,
        rssLink: '',
        theme: 'white',
        rssGoodLink: false,
      };
    },

    computed: {
      disableOkButton() {
        return this.name.length < 3 || !this.rssGoodLink;
      },

      rssSetting() {
        const rssData = {
          link: this.rssLink,
          theme: this.theme,
          time: this.duration,
        };

        const settings = getRSSAppSettings(rssData);

        return settings;
      },
    },

    methods: {
      createRssWidget() {
        const data = {
          name: this.name,
          duration: this.duration,
          link: this.rssLink,
          theme: this.theme,
        };

        this.$emit('createWidget', data);
        this.closeModal();
      },

      closeModal() {
        this.$emit('closeModal');
      },

      handleRssLink(value) {
        this.rssGoodLink = value;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .group-body {
    display: flex;
    gap: 20px;
    flex-direction: column;
    align-items: center;
    margin-right: -16px;
    padding-right: 16px;

    .form-group {
      width: 100%;
      margin-bottom: 0px;
      max-width: 480px;

      label {
        display: flex;
        flex-direction: column;
        margin-bottom: 0;
        gap: 8px;
        font-weight: 500;
        line-height: 24px;

        input,
        select {
          padding: 8px 16px;
          border: 2px solid $borderGrey;
          border-radius: 8px;
          font-size: 16px;
        }
      }
    }
  }

  .theme-options {
    display: flex;
    margin-top: 8px;
  }

  .rss-preview {
    width: 100%;
    max-width: 480px;
    height: 200px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
  }
</style>
